/**
 * Common Translations - English (EN-US)
 */
export const commonEn = {
  // Actions
  'common.actions.next': 'Next',
  'common.actions.back': 'Back',
  'common.actions.cancel': 'Cancel',
  'common.actions.close': 'Close',
  'common.actions.edit': 'Edit',
  'common.actions.submit': 'Submit',
  'common.actions.tryAgain': 'Try Again',
  'common.actions.retry': 'Retry',

  // States
  'common.states.loading': 'Loading...',
  'common.states.submitting': 'Submitting...',

  // Labels
  'common.labels.required': '*',
  'common.labels.optional': '(Optional)',
  'common.labels.step': 'Step {{current}} of {{total}}',
}
